import React, { useEffect, useState } from "react";
import { Route, useNavigate, Navigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setAuthorization } from "@workspace/common/src/helpers/api_helper";
import { useProfile } from "@workspace/login";
import { Actions } from "@workspace/login";
import { UseURLDataHook } from "@workspace/common";
import { fetchCandidateByEmail } from "@workspace/portfolio/src/store/actions";

const CandidateProtected = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isCandidate, setIsCandidate] = useState(null);
  // const [candidateInfo, setCandidateInfo] = useState(null);

  const { userProfile, loading, token } = useProfile();
  const { logoutUser } = Actions;
  const { redirectURL, isRedirect } = UseURLDataHook.useURLData();

  const candidateInfo = useSelector(
    (state) => state?.CandidateUserReducer?.candidateInfo
  );

  useEffect(() => {
    const userGroup = userProfile?.user?.userGroup || [];
    const allowedGroups = ["Candidate Group"];
    const isCandidateUser = userGroup.some((group) =>
      allowedGroups.includes(group.groupName)
    );
    setIsCandidate(isCandidateUser);
  }, [userProfile]);

  useEffect(() => {
    if (isCandidate) {
      const userEmail = userProfile?.user?.email;
      if (userEmail) {
        dispatch(fetchCandidateByEmail({ email: userEmail }));
      }
    }
  }, [dispatch, isCandidate, userProfile]);

  useEffect(() => {
    if (userProfile && !loading && token && candidateInfo) {
      setAuthorization(token);
      if (candidateInfo?.id) {
        navigate(`/candidate/${candidateInfo.id}/edit`);
      } else {
        navigate("/candidate/portfolio/builder");
      }
    } else if (!userProfile && !token && !loading) {
      if (isRedirect) {
        window.location.replace(
          `/login?redirectURL=${encodeURIComponent(redirectURL)}`
        );
      } else {
        dispatch(logoutUser());
      }
    }
  }, [
    userProfile,
    loading,
    token,
    dispatch,
    isRedirect,
    logoutUser,
    redirectURL,
    candidateInfo,
    navigate,
  ]);

  if (!userProfile && !loading && !token) {
    return (
      <Navigate
        to={{ pathname: "/candidate/login", state: { from: props.location } }}
      />
    );
  }

  if (isCandidate === false) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{props.children}</>;
};

const CandidateAccessRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        return (
          <>
            <Component {...props} />
          </>
        );
      }}
    />
  );
};

export { CandidateProtected, CandidateAccessRoute };
